import classNames from 'classnames/bind';
import { SkeletonLine } from 'koba/components/SkeletonPost';

import React from 'react';

import styles from './EventCardSkeleton.module.scss';

const cx = classNames.bind(styles);

const EventCardSkeleton = () => {
  return (
    <div className={cx('event-card-skeleton__container')} data-qa="event-card-skeleton">
      <SkeletonLine height="160px" width="100%" />
      <div className={cx('event-card-skeleton__body')}>
        <SkeletonLine height="16px" width="40%" />
        <div className={cx('event-card-skeleton__description')}>
          <SkeletonLine height="16px" width="60%" />
        </div>
      </div>
    </div>
  );
};

export default EventCardSkeleton;
